import * as React from 'react'
import {ObjUtil} from 'yougile-util'
import {DataObjectId, HubData, PermissionRoleKey} from 'yougile-model'
import {useSyncEvent} from '@containers/hooks'
import {Sync} from '../../client/sync'
import {globals} from '../../extensions/globals-base'
import {Project} from '../../extensions/project'
import {UserAccess} from '../../extensions/user-access'
import {UserUtils} from '../../extensions/user-utils'
import {ProjectParticipantsBase} from './project-participants-base'
import {ProjectParticipantsProps} from './types'

export const NewProjectPopup = (props: ProjectParticipantsProps) => {
  const {type, close} = props
  const box = Sync.getCurrentSandbox()

  const getUsers = () => UserUtils.sortByName(box.getAllUsers(false))
  const [allUsers, setAllUsers] = React.useState(getUsers())
  const roles: {[userId: string]: PermissionRoleKey} = {
    [globals.currentUserId]: 'admin'
  }

  useSyncEvent(
    'current',
    {debounceTime: 1000, filter: '*'},
    () => {
      const users = getUsers()
      if (users.length !== allUsers.length) {
        setAllUsers(users)
      }
    },
    [allUsers]
  )

  const save = (
    id: DataObjectId,
    projectTitle: string,
    chosen: {[userId: string]: PermissionRoleKey},
    addedRoles: HubData['roles']
  ) => {
    const newProj = Project.createNew(
      box.companyId,
      projectTitle,
      true,
      true,
      id,
      type
    )
    if (addedRoles) {
      newProj.data.roles = addedRoles
    }
    close()
    ObjUtil.forEach(chosen, (uid: DataObjectId, role) => {
      UserAccess.setRoleInProject(uid, newProj, role)
    })
  }

  return (
    <ProjectParticipantsBase
      {...props}
      allUsers={allUsers}
      roles={roles}
      save={save}
      requestedNewRole={false}
    />
  )
}
